var React = require('react');

function ChevronLeft (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"Group_312","data-name":"Group 312","transform":"translate(-799.27 1946.893) rotate(-135)"},[React.createElement("rect",{"id":"Rectangle_63","data-name":"Rectangle 63","width":"25.661","height":"2.603","transform":"translate(773 1929)","fill":"#3973b7","key":0}),React.createElement("rect",{"id":"Rectangle_64","data-name":"Rectangle 64","width":"25.661","height":"2.603","transform":"translate(796.058 1954.661) rotate(-90)","fill":"#3973b7","key":1})]));
}

ChevronLeft.defaultProps = {"width":"19.986","height":"36.29","viewBox":"0 0 19.986 36.29"};

module.exports = ChevronLeft;

ChevronLeft.default = ChevronLeft;
